import { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { TracksSearchBarProps } from "./types";
import { CustomTextField } from "./styles";
import CustomButton from "../CustomButton/CustomButton";

export const TracksSearchBar: React.FC<TracksSearchBarProps> = ({
  setTracks,
  setPage,
  queryValue,
  setQueryValue,
  setFilterAndSortChanged,
}) => {
  const [query, setQuery] = useState<string>("");
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const escapeRegex = (input: string) => {
    return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    if (e.target.value.trim() === "") {
      setQueryValue("");
      setPage(0);
      setTracks([]);
      setFilterAndSortChanged(false);
    }
  };

  useEffect(() => {
    if (queryValue === "") {
      setQuery("");
      setFilterAndSortChanged(false);
    }
  }, [queryValue, setFilterAndSortChanged]);

  const handleEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && query.trim() !== "") {
      setFilterAndSortChanged(true);
      setQueryValue(escapeRegex(query.trim()));
      setPage(0);
      setTracks([]);
    }
  };

  return (
    <>
      <CustomTextField
        sx={{
          width: isSmallScreen ? "90vw" : "300px",
        }}
        value={query}
        placeholder="Search tracks"
        onKeyPress={handleEnterPress}
        size={isSmallScreen ? "small" : "medium"}
        onChange={handleQueryChange}
        InputProps={{
          endAdornment: (
            <Fragment>
              <CustomButton
                onClick={() => {
                  if (query.trim() !== "") {
                    setFilterAndSortChanged(true);
                    setPage(0);
                    setTracks([]);
                    setQueryValue(escapeRegex(query.trim()));
                  }
                }}
                text="Search"
              />
            </Fragment>
          ),
        }}
      />
    </>
  );
};
